/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 15/01/2021
 */

// eslint-disable-next-line no-unused-vars
import {FiscalContact} from "../api";
import {toFormDataForCart} from "./../core/utils";
import {addressCatalogRequest, cartBaseRequest, createFiscalContactRequest} from "../api/models";
import removeFiscalContactRequest from "./../api/models/fiscal_contact/remove.request";

const fiscalContactModule = {
    namespaced: true,
    state: {
        fiscalContacts: null,
        states: [],
        municipalities: [],
        neighborhoods: []

    },
    getters: {
        /*countCheckoutItems: state => {
            return state.cartData.tramitesCheckoutItems
        },*/
    },
    actions: {
        async getFiscalContacts({dispatch, commit}, request = cartBaseRequest()){
            dispatch('alerts/showLoading', 'Obteniendo listado de contactos.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            FiscalContact.getFiscalContacts(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setFiscalContacts', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async createFiscalContact({dispatch, commit}, request = createFiscalContactRequest()){
            dispatch('alerts/showLoading', 'Enviando información para crear el contacto.', { root: true })
            commit('removeFiscalContacts')

            await dispatch('account/checkAuthExpiration', null, { root: true })


            FiscalContact.creatFiscalContact(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setFiscalContacts', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async deleteFiscalContact({dispatch, commit}, request = removeFiscalContactRequest()){
            dispatch('alerts/showLoading', 'Eliminando el contacto.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })
            commit('removeFiscalContacts')

            FiscalContact.deleteFiscalContact(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setFiscalContacts', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async getAddressCatalog({dispatch, commit}, request = addressCatalogRequest()){
            dispatch('alerts/showLoading', 'Obteniendo catálogo de estados y municipios.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            if (request.catalog === 'municipalities'){
                commit('removeMunicipalities')
            }else if (request.catalog === 'neighborhoods'){
                commit('removeNeighborhoods')
            }

            FiscalContact.getAddressCatalog(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setAddressCatalog', {type: request.catalog, data: data.datos})
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async updateFiscalContact({dispatch, commit}, request = createFiscalContactRequest()){
            dispatch('alerts/showLoading', 'Actualizando información de contacto.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })
            commit('removeFiscalContacts')


            FiscalContact.updateFiscalContact(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setFiscalContacts', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },
    },
    mutations: {
        setFiscalContacts(state, data){
            state.fiscalContacts = data
        },
        removeFiscalContacts(state){
            state.fiscalContacts = null
        },
        removeMunicipalities(state){
            state.municipalities = []
            state.neighborhoods = []
        },

        removeNeighborhoods(state){
            state.neighborhoods = []
        },

        setAddressCatalog(state, response){
            if (response.type === 'states'){
                state.states = response.data
            }else if(response.type === 'municipalities'){
                state.municipalities = response.data
            }else if(response.type === 'neighborhoods'){
                state.neighborhoods = response.data
            }
        }
    }
}

export default fiscalContactModule